/* Component in IndexShotsPage to create an IndexShot */
import React, { useState, useRef } from "react"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import styles from "../../styles/Indexes.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"

import Upload from "../../assets/upload.png"
import Alert from "react-bootstrap/Alert"
import Asset from "../../components/Asset"
import { useParams } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import { Image } from "react-bootstrap"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast"

const MAX_FILE_SIZE_MB = 5
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

const IndexShotCreate = ({ setShow, setHasOrder, seriesName }) => {
  const host = useHostName()
  const [errors, setErrors] = useState({})
  const { id } = useParams()
  const [postData, setPostData] = useState({
    number: "",
    content: "",
    image: "",
  })
  const [file, setFile] = useState(null);


  const { number, content } = postData

  const imageInput = useRef(null)

  const validateFileSize = (file, inputRef) => {
    if (file.size <= MAX_FILE_SIZE_BYTES) {
      return true
    }

    if (inputRef?.current) {
      inputRef.current.value = ""
    }

    toast.error(`Only ${MAX_FILE_SIZE_MB} MB files are allowed.`)
    return false
  }

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  // const handleChangeImage = (event) => {
  //   if (event.target.files.length) {
  //     URL.revokeObjectURL(image)
  //     setPostData({
  //       ...postData,
  //       image: URL.createObjectURL(event.target.files[0]),
  //     })
  //     console.log(`image ${image}`)
  //   }
  // }

  const handleChangeFile = (e) => {
    const uploadedFile = e.target.files[0]
    if (!uploadedFile) {
      return
    }
    if (!validateFileSize(uploadedFile, imageInput)) {
      return
    }
    setFile(uploadedFile)
  }


  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData()

    // Validate number
    if (!number || !/^\d+$/.test(number)) {
      toast.error("An Indexshot Number Must be Added", {
        duration: 2500,
        position: "top-right",
      });
      return;
    }

    // Validate image
    // if (!image) {
    //   toast.error("An Image Must be Added", {
    //     duration: 2500,
    //     position: "top-right",
    //   });
    //   return;
    // }

    formData.append("series_id", id)
    formData.append("series_name", seriesName)
    formData.append("number", number)
    formData.append("content", content)
    if (imageInput.current.files[0]) {
      formData.append("image", imageInput.current.files[0])
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const data = await axiosReq.post("/indexshots/", formData)
        if (data?.success === false) {
          toast.error(data?.error?.response?.data.non_field_errors[0], {
            duration: 3000,
            position: "top-right",
          });
        }
        else {
          toast.success(`IndexShot Added`);
          setHasOrder(true)
          setShow(false)
        }   
      } else {
       const data  =  await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/indexshots/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )

        if (data?.success === false) {
          toast.error(data?.error?.response?.data.non_field_errors[0], {
            duration: 3000,
            position: "top-right",
          });
        }
        else {
          toast.success(`IndexShot Added Successfully!`);
          setPostData({ content: '', image: null, number: '' })
          setFile(null)
          setHasOrder(true)
          setShow(false)
        }
      }
    } catch (err) {
      console.log(err)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const buttons = (
    <div className="text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} mr-3 px-3 px-md-5`}
        onClick={() => setShow(false)}
      >
        Cancel
      </Button>
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} ml-3 px-3 px-md-5`}
        type="submit"
      >
        Create
      </Button>
    </div>
  )

  return (
    <div className="mt-3">
    <Row>
    <Col xs={12} md={{span: 8, offset: 2}}>
    <h5 className={`text-center ${styles.SubTitle }`}
             style={{ textTransform: 'uppercase'}}>Create Indexshot</h5>
    <Form className={`text-center mb-4 px-3 ${styles.Back }`} 
      onSubmit={handleSubmit}>
      <Row className="mt-3">
        <Col xs={12} md={6}>
          <div className="d-flex justify-content-center">
            <Form.Group
              controlId="number"
              className={`${styles.Width} text-center`}
            >
              <Form.Label className={`${styles.BoldScene} `}>Number</Form.Label>
              <Form.Control
                className={styles.Input}
                type="text"
                name="number"
                value={number}
                onChange={handleChange}
              />
            </Form.Group>
            {errors?.number?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
          </div>
          <div className="d-flex justify-content-center mt-3">
            <Form.Group
              controlId="content"
              className={`${styles.Width90}  text-center`}
            >
              <Form.Label className={`${styles.BoldScene}`}>Content</Form.Label>
              <Form.Control
                type="text"
                className={styles.InputScene}
                as="textarea"
                name="content"
                rows={2}
                value={content}
                onChange={handleChange}
              />
            </Form.Group>
            {errors?.content?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
          </div>
        </Col>
        <Col xs={12} md={6} className="p-0">
          <div className={`d-flex flex-column justify-content-center pt-0 mt-0`}>
            <p className={`${styles.BoldScene} pb-2`}>Shot</p>
            <Form.Group className="text-center">
              {file && file.type.startsWith("image/") ? (
                <>
                  <figure>
                    <Image
                      width="70%"
                      height="120px"
                      style={{ borderRadius: 8, border: "none" }}
                      src={URL.createObjectURL(file)}
                      className={`${appStyles.iframe} rounded`}
                    />
                  </figure>
                  <div>
                    <Form.Label
                      className={`${btnStyles.Button} ${btnStyles.GreyDark} mt-2`}
                      htmlFor="file-upload"
                    >
                      Change the Image
                    </Form.Label>
                  </div>
                </>
              ) : file && file.type === "application/pdf" ? (
                <>
                  <iframe
                    src={URL.createObjectURL(file)}
                    width="50%"
                    height="100px"
                    style={{ borderRadius: 8, border: "none" }}
                    title="PDF Preview"
                  />
                  <div>
                    <Form.Label
                      className={`${btnStyles.Button} ${btnStyles.GreyDark} mt-3`}
                      htmlFor="file-upload"
                    >
                      Change the Image
                    </Form.Label>
                  </div>
                </>
              ) : (
                <Form.Label
                  className="d-flex justify-content-center"
                  htmlFor="file-upload"
                >
                  <Asset src={Upload} message="Upload Image or PDF" />
                </Form.Label>
              )}

              <Form.Control
                type="file"
                id="file-upload"
                accept="image/*,application/pdf"
                onChange={handleChangeFile}
                ref={imageInput}
              />
            </Form.Group>
            {errors?.image?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className={` my-3`}>{buttons} </div>
        </Col>
      </Row>
    </Form>
    </Col>
    </Row>
    </div>
  )
}

export default IndexShotCreate
